module.exports = "<div class=\"ot-hire\">\n<a ng-click=\"vm.openLoginModal('login')\"><span class=\"icon-login\"></span>\n  <span class=\"hidden-xs hidden-sm\">{{\"HEADER.LOGIN\" | translate}}</span>\n  <span class=\"hidden-md hidden-lg hidden-xl\">{{\"HEADER.SIGN_UP\" | translate}}</span>\n</a>\n<button class=\"btn btn-default hidden-xs hidden-sm\" ng-click=\"vm.openLoginModal('signup')\">\n  {{\"HEADER.SIGN_UP\" | translate}}\n</button>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/hire.html
 ** module id = 285
 ** module chunks = 1
 **/